// Unpublished Work © 2024 Deere & Company.

import t from 'tcomb';

export const FilingDetails = t.struct({
    filingStateCode: t.String
}, {
    defaultProps: {
        filingStateCode: ''
    },
    name: 'FilingDetails'
});
